import React from 'react';
import {PropTypes} from 'prop-types';
import {NormalizeClassNameString, ToString} from './utils';
import {IsObjectsEqualsByMap} from './123';
import {SimpleTooltip} from './tooltip';

import './locksymbol.scss';

const availabilityInfoMap = {
    IsAllowed: false,
    Message: ''
}

export class LockSymbolComponent extends React.Component{
    constructor(props, ...others) {
        super(props, ...others);
        
        this.isHidden = this.isHidden.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        const props = this.props;

        const result = 
            (nextProps.className != props.className) || 
            (nextProps.animated != props.animated) ||
            (nextProps.renderHidden != props.renderHidden) ||
            !IsObjectsEqualsByMap(nextProps.availabilityInfo, props.availabilityInfo, availabilityInfoMap);
        
        return result;
    }

    isHidden() {
        const {availabilityInfo} = this.props;

        const result = !Boolean(availabilityInfo) || Boolean(availabilityInfo.IsAllowed);

        return result;
    }

    render() {
        const self = this;
        const {availabilityInfo, animated, renderHidden} = self.props;

        let className = ToString(self.props.className) + ' lock-symbol';
        const isHidden = self.isHidden();
        if (isHidden) {
            className += Boolean(renderHidden) ? ' invisible' : ' d-none';
        }

        return (
            <SimpleTooltip
                title={availabilityInfo?.Message || ''}
                visible={!isHidden}
                isHtml={availabilityInfo?.IsHtml || false}
            >
                <span className={NormalizeClassNameString(className)}>
                    <span className={'fa fa-lock' + (Boolean(animated) ? ' fa-pulse-shrink' : '')} />
                </span>
            </SimpleTooltip>
        )
    }
}
LockSymbolComponent.propTypes = {
    availabilityInfo: PropTypes.shape({Message: PropTypes.string, IsAllowed: PropTypes.bool.isRequired}),
    className: PropTypes.string,
    animated: PropTypes.bool,
    renderHidden: PropTypes.bool
}
LockSymbolComponent.defaultProps = {
    className: '',
    animated: false,
    renderHidden: false
}
